module.exports = __webpack_public_path__ + "static/media/enEsperaImg.09ab2223.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/enEsperaImg.png
// module id = 2020
// module chunks = 0